var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":"","title":`Editando Viaje ${_vm.delivery ? _vm.delivery.drivInCode: ''}`},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(_vm.delivery)?_c('DeliveryForm',{attrs:{"delivery":_vm.delivery,"editMode":_vm.editMode},on:{"done":_vm.onDoneDeliveryModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }